import { motion } from "motion/react";
import React from "react";
import { Button } from "./Button";
export var StickyCTA = function StickyCTA(param) {
  var firstCTA = param.firstCTA,
    secondCTA = param.secondCTA;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(motion.div, {
    className: "fixed bottom-0 left-1/2 -translate-x-1/2 z-50 lg:hidden h-fit flex container-page w-full justify-center items-center",
    initial: {
      y: 100,
      opacity: 0,
      x: "-50%"
    },
    animate: {
      y: 0,
      opacity: 1,
      x: "-50%"
    },
    transition: {
      type: "tween",
      ease: "easeInOut",
      duration: 0.5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: " flex flex-row gap-1.5 items-center justify-center bg-primary-white rounded-t-7.5 py-1.5 w-full min-w-[290px] max-w-[320px] shadow-sticky-cta "
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary-no-border",
    size: "extra-small",
    href: firstCTA.href,
    icon: firstCTA.icon,
    text: firstCTA.text
  }, firstCTA.children), secondCTA && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary-no-border",
    size: "extra-small",
    href: secondCTA.href,
    icon: secondCTA.icon,
    text: secondCTA.text
  }, secondCTA.children))));
};